module.exports = __webpack_public_path__ + "static/media/Sample - 3.0d426f86.pdf";